import Toggle from "../../../components/Toggle";

export default function TipNDAStep({ data, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <div style={{ width: "100%" }}>
        <Toggle
          label="NDA Bilateral"
          description="Ambele parti dezvaluie si primesc informatii confidentiale. Dezactiveaza pentru NDA unilateral (o parte dezvaluie, cealalta primeste)."
          checked={!!data.bilateral}
          onChange={() => update("bilateral")(!data.bilateral)}
        />
      </div>

      <div style={{
        width: "100%",
        padding: "16px 20px",
        backgroundColor: "#fdfbf7",
        borderRadius: "12px",
        border: "2px solid #e8e0d4",
      }}>
        <div style={{ fontSize: "14px", color: "#2d2418", fontWeight: 600, fontFamily: "'DM Sans', sans-serif", marginBottom: "4px" }}>
          {data.bilateral ? "NDA Bilateral" : "NDA Unilateral"}
        </div>
        <div style={{ fontSize: "13px", color: "#8a7e70", fontFamily: "'DM Sans', sans-serif", lineHeight: 1.6 }}>
          {data.bilateral
            ? "Ambele parti dezvaluie informatii confidentiale si se obliga reciproc sa le protejeze. Ideal pentru negocieri, parteneriate sau colaborari unde ambele parti impartasesc informatii sensibile."
            : "O singura parte dezvaluie informatii confidentiale, iar cealalta parte se obliga sa le protejeze. Ideal cand angajezi un freelancer, externalizezi servicii sau discuti cu un potential partener."}
        </div>
      </div>
    </div>
  );
}
